import { HttpClient } from "aurelia-fetch-client";
import { autoinject } from "aurelia-framework";
import { ContractLine, Feature } from "./customer-info-store";
import { ReportBuilder } from "./usage/report-builder";

export interface UsageReport {
    usageReportPeriod: UsageReportPeriod;
    reportItems: UsageReportItem[];
}

export interface UsageReportPeriod {
    startDate: string;
    endDate: string;
    interval: UsageIntervalEnum;
}

export interface UsageReportItem {
    type?: UsageReportItemType;
    startDate: string;
    endDate: string;
    xAxisValue: Date;
    count: number;
    cumulativeCount: number;
    isCurrentItem?: true;
    isStartItem?: true;
}

export enum UsageReportItemType {
    Planned = "Planned",
    Actual = "Actual",
    ActualPrevious = "Previous Period",
    Forecast = "Forecast",
}

export enum UsageIntervalEnum {
    Day = 0,//"Day",
    Month = 1,//"Month",
}

@autoinject
export class UsageStore {
    private cache: Map<string, UsageReport> = new Map<string, UsageReport>();

    /**
     *
     */
    constructor(private http: HttpClient) {

        http.configure(config => {
            config
                .useStandardConfiguration();
        });
    }

    async retrieveBundleReport(organizationId: string, contractLine: ContractLine): Promise<UsageReport> {
        if (this.cache.has(contractLine.contractLineId)) {
            return new Promise<UsageReport>((resolve, reject) => {
                setTimeout(() => {
                    const cachedReport: UsageReport = this.cache.get(contractLine.contractLineId) as UsageReport;

                    resolve(cachedReport);
                }, 1000);
            });
        }

        const reportBuilder = new ReportBuilder(contractLine);

        const bundlePeriod = reportBuilder.getBundlePeriod(contractLine);
        
        console.log('get usage for bundle period', bundlePeriod);

        const usageReport: UsageReport = await this.retrieveUsage(organizationId, contractLine.contractLineId, bundlePeriod);
        
        console.log('Build usage report:', usageReport);

        const completeUsageReport = reportBuilder.buildReport(usageReport);

        console.log('Usage report:', completeUsageReport);

        this.cache.set(contractLine.contractLineId, completeUsageReport);

        return completeUsageReport;
    }

    public async retrieveUsage(organizationId: string, contractLineId: string, reportPeriod: UsageReportPeriod): Promise<UsageReport> {
        const url = `/api/apimsubscription/usagereport/${organizationId}/${contractLineId}?startDate=${reportPeriod.startDate}&endDate=${reportPeriod.endDate}&interval=${reportPeriod.interval}`;

        let response: Response = await this.http.fetch(url);

        if (response.ok) {
            return await response.json();
        }

        const emptyResult: UsageReport = {
            usageReportPeriod: reportPeriod,
            reportItems: []
        };

        return emptyResult;
    }
}


// WEBPACK FOOTER //
// ./ClientApp/app/services/usage-store.ts